import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const InvestmentMemos = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="investmentmemos"
            prevLink={ROUTE_NAME.FAQ_REPAYMENTS}
            prevTitle={dict.repayments}
            nextLink={ROUTE_NAME.FAQ_RISK_MANAGEMENT}
            nextTitle={dict.riskManagement}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.investmentMemos}
                        </h3>
                    </div>
                    <p>
                        <strong>
                            {dict.investmentMemosTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentMemosTitle1Text1}
                    </p>
                    <p>
                        {dict.investmentMemosTitle1Text2}
                    </p>
                    <p>
                        {dict.investmentMemosTitle1Text3}
                    </p>
                    <p>
                        <strong>
                            {dict.investmentMemosTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.investmentMemosTitle2Text1}
                    </p>
                    <p>
                        {dict.investmentMemosTitle2Text2}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default InvestmentMemos;
